module.exports = "/assets/data/e3233e13091de904a8876bcdbe5d65b9-LS27.data.json";